// extracted by mini-css-extract-plugin
export var accordion = "_ig-0";
export var chevron = "_ig-3";
export var closed = "_ig-2";
export var content = "_ig-4";
export var open = "_ig-1";
export var rotate = "_ig-5";